import styled from '@emotion/styled';
import { Link, useLocation } from 'react-router-dom';
import {
  ACCOUNT_ROUTE,
  CLIENT_LIST_ROUTE,
  DASHBOARD_ROUTE,
  ESTIMATE_LIST_ROUTE,
  INVOICE_LIST_ROUTE,
} from '~/constants/routes';
import ClientsIcon from '~/icons/ClientsIcon';
import DashboardIcon from '~/icons/DashboardIcon';
import EstimateIcon from '~/icons/EstimateIcon';
import InvoiceIcon from '~/icons/InvoiceIcon';
import SettingsIcon from '~/icons/SettingsIcon';
import { useMobileCta } from './SidebarLayout';

const NavWrapper = styled.nav`
  width: 100vw;
  background: var(--white, #fff);
  border-top: 1px solid var(--border1, #e0e0e0);
  padding-bottom: env(safe-area-inset-bottom);
`;

const ButtonWrapper = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const NavItem = styled(Link, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>`
  background: none;
  border: none;
  outline: none;
  text-decoration: none;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ active }) => (active ? 'var(--prim4)' : 'var(--neut3)')};
  font-size: 12px;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  padding: 6px 0;
  cursor: pointer;
  transition: color 0.2s;

  svg {
    font-size: 22px;
    margin-bottom: 2px;
  }
`;

const routes = [
  {
    path: DASHBOARD_ROUTE,
    pattern: /^\/private\/dashboard$/,
    label: 'Dashboard',
    icon: DashboardIcon,
  },
  {
    path: ESTIMATE_LIST_ROUTE,
    pattern: /^\/private\/estimates.*/,
    label: 'Estimates',
    icon: EstimateIcon,
  },
  {
    path: INVOICE_LIST_ROUTE,
    pattern: /^\/private\/invoices.*/,
    label: 'Invoices',
    icon: InvoiceIcon,
  },
  {
    path: CLIENT_LIST_ROUTE,
    pattern: /^\/private\/clients.*/,
    label: 'Clients',
    icon: ClientsIcon,
  },
  {
    path: ACCOUNT_ROUTE,
    pattern: /^\/private\/account$/,
    label: 'Account',
    icon: SettingsIcon,
  },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const { mobileCta } = useMobileCta();

  return (
    <NavWrapper>
      {mobileCta && <ButtonWrapper>{mobileCta}</ButtonWrapper>}
      <InnerWrapper>
        {routes.map(eachRoute => {
          const active = eachRoute.pattern.test(location.pathname);
          return (
            <NavItem
              key={eachRoute.label}
              active={active}
              to={eachRoute.path}
              aria-label={eachRoute.label}
            >
              <eachRoute.icon fill={active ? 'var(--prim4)' : 'var(--neut3)'} />
              {eachRoute.label}
            </NavItem>
          );
        })}
      </InnerWrapper>
    </NavWrapper>
  );
}
